module.exports = __webpack_public_path__ + "img/logo_dark.a8b1977f.png";